import {
  debuggingUserStatus,
  debuggingIdealDefrag,
  debuggingDecorateEvents,
  debuggingFilterRooms,
  USER_STATUS,
  experiments,
} from "../state/local-storage";
import { EXPERIMENT_FLAGS } from "@util/experiment.util";
import { getReduxStore } from "@state/redux-store";
import { setActiveViewEvent } from "@actions/chrome-extension.actions";
import { windowLocation } from "@util/location.util";

const getInterface = () => {
  if (!(window as any).clockwise) {
    (window as any).clockwise = {
      help: displayHelp,
      go,
    };
  }
  return (window as any).clockwise;
};

///////////
// HELP
////////////
const DEBUGGER_HELP_TOP = `
%c•----------------------------------------------------•
|           CLOCKWISE DEBUGGER INTERFACE             |
|----------------------------------------------------|
|  .clockwise:                                       |
|    .help() %c// you are here%c                         |
|    .go: %c // url helpers%c                            |
|      .defenderInvite(tokenId, orgId, eventId)      |
|      .eventView(calendarId, externalEventId)       |`;
const DEBUGGER_HELP_BOTTOM = `
•----------------------------------------------------•`;
const DEBUGGER_HELP_IDEAL_DEFRAG = `
|    .idealDefrag() %c // toggle ideal defrag on/off%c   |`;
const DEBUGGER_HELP_DECORATE_EVENTS = `
|    .decorateEvents() %c // toggle decoration on/off%c  |`;
const DEBUGGER_HELP_FILTER_ROOMS = `
|    .filterRooms() %c // toggle room filtering on/off%c |`;
const DEBUGGER_HELP_VIEW = `
|    .view: %c// change the user view applied%c          |
|      .active()                                     |
|      .preview()                                    |
|      .restricted()                                 |
|      .reset()                                      |`;
const DEBUGGER_EXPERIMENTS = `
|    .experiments: %c// from local storage %c            |
|      .all() %c// view all currently set%c              |
|      .[keyOfExperiment]() %c// toggle experiment%c     |`;

const displayHelp = () => {
  const clockwise = getInterface();
  const baseStyle = "font-family: courier; font-size: 12px; background-color: #1C2B34;";
  const codeStyle = baseStyle + "color: #eee;";
  const commentStyle = baseStyle + "color: #aaa;";
  let help = DEBUGGER_HELP_TOP;
  const styles = [codeStyle, commentStyle, codeStyle, commentStyle, codeStyle];
  if (!!clockwise.idealDefrag) {
    help += DEBUGGER_HELP_IDEAL_DEFRAG;
    styles.push(commentStyle, codeStyle);
  }
  if (!!clockwise.decorateEvents) {
    help += DEBUGGER_HELP_DECORATE_EVENTS;
    styles.push(commentStyle, codeStyle);
  }
  if (!!clockwise.filterRooms) {
    help += DEBUGGER_HELP_FILTER_ROOMS;
    styles.push(commentStyle, codeStyle);
  }
  if (!!clockwise.view) {
    help += DEBUGGER_HELP_VIEW;
    styles.push(commentStyle, codeStyle);
  }
  if (!!clockwise.experiments) {
    help += DEBUGGER_EXPERIMENTS;
    styles.push(commentStyle, codeStyle, commentStyle, codeStyle, commentStyle, codeStyle);
  }
  help += DEBUGGER_HELP_BOTTOM;
  console.log(help, ...styles);
};

//////////////////
// GO
//////////////////

export const go = {
  defenderInvite: () => {
    const inputs = window.prompt("Just paste the row in from the postgres cli");
    if (!!inputs) {
      const [tokenId, orgId, , eventId] = inputs.split("|");
      const base = window.location.origin;
      const cleanToken = tokenId.trim();
      const cleanOrg = orgId.replace(/-/g, "").trim();
      const cleanEvent = eventId.trim();
      const url = `${base}/hello/0-${cleanToken}-${cleanOrg}-${cleanEvent}`;
      windowLocation.assign("DebuggerInvite", url);
    } else {
      console.error("hey, you didn't enter anything!");
    }
  },
  eventView: (calendarId: string, externalEventId: string) => {
    const action = setActiveViewEvent(externalEventId, calendarId, false);
    getReduxStore().dispatch(action);
  },
};

//////////////////
// IDEAL DEFRAG
//////////////////

export const isIdealDefragOn = () => {
  return debuggingIdealDefrag.get() === "on";
};

const toggleIdealDefrag = (component: React.Component<any, any>) => {
  if (isIdealDefragOn()) {
    debuggingIdealDefrag.remove();
  } else {
    debuggingIdealDefrag.set("on");
  }
  component.forceUpdate();
};

export const initIdealDefrag = (component: React.Component<any, any>) => {
  const clockwise = getInterface();
  clockwise.idealDefrag = toggleIdealDefrag.bind(null, component);
};

//////////////////
// DECORATE EVENTS
//////////////////

export const isDecorateEventsOn = () => {
  return debuggingDecorateEvents.get() === "on";
};

const toggleDecorateEvents = (component: React.Component<any, any>) => {
  if (isDecorateEventsOn()) {
    debuggingDecorateEvents.remove();
  } else {
    debuggingDecorateEvents.set("on");
  }
  component.forceUpdate();
};

export const initDecorateEvents = (component: React.Component<any, any>) => {
  const clockwise = getInterface();
  clockwise.decorateEvents = toggleDecorateEvents.bind(null, component);
};

//////////////////
// FILTER ROOMS
//////////////////

export const isFilterRoomsOn = () => {
  return debuggingFilterRooms.get() === "on";
};

const toggleFilterRooms = (component: React.Component<any, any>) => {
  if (isFilterRoomsOn()) {
    debuggingFilterRooms.remove();
  } else {
    debuggingFilterRooms.set("on");
  }
  component.forceUpdate();
};

export const initFilterRooms = (component: React.Component<any, any>) => {
  const clockwise = getInterface();
  clockwise.filterRooms = toggleFilterRooms.bind(null, component);
};

//////////////////
// VIEW
//////////////////
const setUserStatus = (
  userStatus: string,
  component: React.Component<any, any>,
  statusToSet: string,
) => {
  if (!userStatus) {
    return console.error("no valid user present");
  } else if (userStatus !== USER_STATUS.active) {
    return console.error("denied: current user is not an active user");
  } else {
    !statusToSet ? debuggingUserStatus.remove() : debuggingUserStatus.set(statusToSet);
    component.forceUpdate();
  }
};

const generateSetView = (userStatus: string, component: React.Component<any, any>) => {
  const setView: { [s: string]: (...args: any[]) => void } = {
    reset: setUserStatus.bind(null, userStatus, component),
  };
  return Object.keys(USER_STATUS).reduce((accumulator, key) => {
    accumulator[key] = setUserStatus.bind(null, userStatus, component, USER_STATUS[key]);
    return accumulator;
  }, setView);
};

export const initView = (userStatus: string, component: React.Component<any, any>) => {
  if (!userStatus) {
    return;
  }
  const clockwise = getInterface();
  const view = generateSetView(userStatus, component);
  clockwise.view = view;
};

//////////////////
// EXPERIMENTS
//////////////////
const generateExperiementsInterface = (component: React.Component<any, any>) => {
  const experimentInterface: { [key: string]: any } = {
    all: experiments.getAll.bind(null),
  };
  Object.keys(EXPERIMENT_FLAGS).forEach((key) => {
    experimentInterface[key] = () => {
      const flag = (EXPERIMENT_FLAGS as { [key: string]: string })[key];
      experiments.toggleFlag(flag);
      const newState = experiments.getFlag(flag);
      console.log(`'${flag}' is now overriden to be ${newState ? "ON" : "OFF"}`);
      component.forceUpdate();
    };
  });
  return experimentInterface;
};

export const initExperiments = (component: React.Component<any, any>) => {
  const clockwise = getInterface();
  const experimentsInterface = generateExperiementsInterface(component);
  clockwise.experiments = experimentsInterface;
};
